// Mock data for Waterlife Pools & Spas landing page

export const businessInfo = {
  name: "Waterlife Pools & Spas",
  phone: "254-214-8897",
  email: "Waterlifepools01@gmail.com",
  address: "Waco, Texas",
  tagline: "Quality • Reliability • Results",
  description: "Texas's premier pool and spa service company, delivering exceptional quality and craftsmanship since 2010.",
  logo: "https://customer-assets.emergentagent.com/job_page-craft-221/artifacts/ldk2hho1_1000026154.png"
};

export const services = [
  {
    id: 1,
    title: "Custom Pools",
    description: "Design and build your dream pool with our expert team. From concept to completion, we create stunning outdoor living spaces.",
    icon: "waves"
  },
  {
    id: 2,
    title: "Luxury Spas",
    description: "Transform your backyard into a personal oasis with our premium spa installations and custom hot tub solutions.",
    icon: "droplets"
  },
  {
    id: 3,
    title: "Pool Repairs/Liners",
    description: "Expert repair services for all pool types. We fix leaks, cracks, equipment failures, and restore your pool to perfect condition.",
    icon: "wrench"
  },
  {
    id: 4,
    title: "Maintenance",
    description: "Comprehensive maintenance packages to keep your pool crystal clear and equipment running smoothly year-round.",
    icon: "shield-check"
  }
];

export const whyChooseUs = [
  {
    id: 1,
    title: "20+ Years Experience",
    description: "Trusted by thousands of Texas homeowners",
    icon: "award"
  },
  {
    id: 2,
    title: "Licensed & Insured",
    description: "Fully certified professionals you can trust",
    icon: "shield"
  },
  {
    id: 3,
    title: "Quality Guaranteed",
    description: "We stand behind our work with comprehensive warranties",
    icon: "check-circle"
  },
  {
    id: 4,
    title: "24/7 Support",
    description: "Emergency service available when you need us",
    icon: "phone"
  }
];

export const galleryImages = [
  {
    id: 1,
    url: "https://lonestarcomponents.com/wp-content/uploads/2025/07/Savannah-Pacific-Blue-pool-2.jpg",
    title: "Savannah Pacific Blue Pool",
    category: "pools"
  },
  {
    id: 2,
    url: "https://lonestarcomponents.com/wp-content/uploads/2025/07/Santa-Fe-Caribbean-Blue-pool-6.jpg",
    title: "Santa Fe Caribbean Blue Pool",
    category: "pools"
  },
  {
    id: 3,
    url: "https://lonestarcomponents.com/wp-content/uploads/2025/07/phoenix-pacific-Blue-pool-4.jpg",
    title: "Phoenix Pacific Blue Pool",
    category: "pools"
  },
  {
    id: 4,
    url: "https://lonestarcomponents.com/wp-content/uploads/2025/07/Miami-pacific-Blue-pool-3.jpg",
    title: "Miami Pacific Blue Pool",
    category: "pools"
  },
  {
    id: 5,
    url: "https://lonestarcomponents.com/wp-content/uploads/2025/07/Malibu-Saphire-Grey-pool.jpg",
    title: "Malibu Sapphire Grey Pool",
    category: "pools"
  },
  {
    id: 6,
    url: "https://lonestarcomponents.com/wp-content/uploads/2025/07/malibu-Fiji-Blue-pool-6.jpg",
    title: "Malibu Fiji Blue Pool",
    category: "pools"
  },
  {
    id: 7,
    url: "https://lonestarcomponents.com/wp-content/uploads/2025/07/Laguna-Fiji-Blue-pool-4.jpg",
    title: "Laguna Fiji Blue Pool",
    category: "pools"
  },
  {
    id: 8,
    url: "https://lonestarcomponents.com/wp-content/uploads/2025/07/Independence-Caribbean-Blue-pool-4.jpg",
    title: "Independence Caribbean Blue Pool with Tanning Ledge",
    category: "pools"
  },
  {
    id: 9,
    url: "https://lonestarcomponents.com/wp-content/uploads/2025/07/Cabo-serenity-tanning-ledge-Fiji-Blue.jpg",
    title: "Cabo with Spa & Tanning Ledge",
    category: "spas"
  },
  {
    id: 10,
    url: "https://lonestarcomponents.com/wp-content/uploads/2025/07/Cabo-Fiji-Blue-pool-3.jpg",
    title: "Cabo Fiji Blue Pool with Spa",
    category: "spas"
  },
  {
    id: 11,
    url: "https://lonestarcomponents.com/wp-content/uploads/2025/07/Atlantis-Pacific-Blue-pool-6.jpg",
    title: "Atlantis Pacific Blue Pool",
    category: "pools"
  },
  {
    id: 12,
    url: "https://lonestarcomponents.com/wp-content/uploads/2025/07/Cheyenne-Fiji-Blue-pool.jpg",
    title: "Cheyenne Fiji Blue Pool",
    category: "pools"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Sarah Johnson",
    location: "Waco, TX",
    rating: 5,
    text: "Waterlife transformed our backyard into a tropical paradise! The team was professional, on-time, and the quality is exceptional. Best investment we've ever made!",
    image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop"
  },
  {
    id: 2,
    name: "Michael Rodriguez",
    location: "Temple, TX",
    rating: 5,
    text: "We had a major pool leak and Waterlife came out same day. They diagnosed and fixed the problem quickly. Outstanding service and fair pricing!",
    image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=150&h=150&fit=crop"
  },
  {
    id: 3,
    name: "Jennifer Davis",
    location: "Killeen, TX",
    rating: 5,
    text: "Our custom spa is absolutely beautiful! The attention to detail and craftsmanship is top-notch. Highly recommend Waterlife for any pool or spa project.",
    image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=150&h=150&fit=crop"
  },
  {
    id: 4,
    name: "Robert Chen",
    location: "Belton, TX",
    rating: 5,
    text: "From design to completion, Waterlife exceeded our expectations. They guided us through every step and delivered a stunning infinity pool. Our neighbors are jealous!",
    image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop"
  },
  {
    id: 5,
    name: "Amanda Martinez",
    location: "Waco, TX",
    rating: 5,
    text: "We've used Waterlife for maintenance for 3 years now. Always reliable, always professional. Our pool has never looked better. Worth every penny!",
    image: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=150&h=150&fit=crop"
  },
  {
    id: 6,
    name: "David Thompson",
    location: "Harker Heights, TX",
    rating: 5,
    text: "The waterfall feature they installed is incredible! It completely transformed our existing pool. The crew was respectful and cleaned up perfectly every day.",
    image: "https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=150&h=150&fit=crop"
  },
  {
    id: 7,
    name: "Lisa Patel",
    location: "Temple, TX",
    rating: 5,
    text: "Best pool company in Central Texas! They repaired our cracked pool deck and updated our filtration system. Professional, knowledgeable, and honest pricing.",
    image: "https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?w=150&h=150&fit=crop"
  },
  {
    id: 8,
    name: "James Wilson",
    location: "Waco, TX",
    rating: 5,
    text: "Waterlife built our dream pool during COVID and still finished on time! The heated spa attachment is perfect for winter. Couldn't be happier with the results.",
    image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop"
  },
  {
    id: 9,
    name: "Emily Brooks",
    location: "Lorena, TX",
    rating: 5,
    text: "Their smart automation system is a game changer! I can control everything from my phone. The LED lighting they installed makes our pool look like a resort at night.",
    image: "https://images.unsplash.com/photo-1489424731084-a5d8b219a5bb?w=150&h=150&fit=crop"
  },
  {
    id: 10,
    name: "Carlos Sanchez",
    location: "Copperas Cove, TX",
    rating: 5,
    text: "The fiberglass pool installation was so fast! Just like they promised, we were swimming in 10 days. The quality is amazing and maintenance is minimal.",
    image: "https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=150&h=150&fit=crop"
  },
  {
    id: 11,
    name: "Patricia O'Neill",
    location: "McGregor, TX",
    rating: 5,
    text: "Our backyard oasis is the talk of the neighborhood! Waterlife's design team helped us create exactly what we envisioned. Five stars all the way!",
    image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop"
  },
  {
    id: 12,
    name: "Brandon Lee",
    location: "Waco, TX",
    rating: 5,
    text: "Professional from start to finish. They handled all the permits and made the whole process stress-free. The pool is gorgeous!",
    image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=150&h=150&fit=crop"
  },
  {
    id: 13,
    name: "Michelle Garcia",
    location: "Temple, TX",
    rating: 4,
    text: "Great experience overall. The installation took a bit longer due to weather, but the final result exceeded our expectations. Would recommend!",
    image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=150&h=150&fit=crop"
  },
  {
    id: 14,
    name: "Kevin Anderson",
    location: "Killeen, TX",
    rating: 5,
    text: "The tanning ledge and bench seating are perfect for our family. Kids love it, and so do we. Excellent craftsmanship!",
    image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop"
  },
  {
    id: 15,
    name: "Rachel Kim",
    location: "Belton, TX",
    rating: 5,
    text: "Energy-efficient pool heater works like a charm. We can swim year-round now! Thank you Waterlife for the great recommendations.",
    image: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=150&h=150&fit=crop"
  },
  {
    id: 16,
    name: "Thomas Wright",
    location: "Waco, TX",
    rating: 5,
    text: "The saltwater system they installed is so much better than chlorine. No more red eyes or harsh chemicals. Love it!",
    image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop"
  },
  {
    id: 17,
    name: "Angela Foster",
    location: "Harker Heights, TX",
    rating: 5,
    text: "Weekly maintenance service is worth every dollar. Pool is always crystal clear and ready to use. Highly professional team!",
    image: "https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?w=150&h=150&fit=crop"
  },
  {
    id: 18,
    name: "Daniel Murphy",
    location: "Temple, TX",
    rating: 5,
    text: "Fixed our pool equipment issues quickly and efficiently. Fair pricing and honest service. Will definitely use them again!",
    image: "https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=150&h=150&fit=crop"
  },
  {
    id: 19,
    name: "Sophia Nguyen",
    location: "Waco, TX",
    rating: 5,
    text: "The LED color-changing lights are stunning! Pool parties have never been better. Installation was quick and clean.",
    image: "https://images.unsplash.com/photo-1489424731084-a5d8b219a5bb?w=150&h=150&fit=crop"
  },
  {
    id: 20,
    name: "Christopher Hall",
    location: "Killeen, TX",
    rating: 5,
    text: "Resurfaced our old pool and it looks brand new! The team was meticulous and the finish is flawless. Great job!",
    image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=150&h=150&fit=crop"
  }
  // Continuing with 89 more testimonials to reach 109 total...
];

// Generate additional 89 testimonials programmatically
const texasCities = ["Waco", "Temple", "Killeen", "Belton", "Harker Heights", "Copperas Cove", "Lorena", "McGregor", "Hewitt", "Woodway"];
const serviceTypes = [
  "pool installation", "spa installation", "pool repair", "maintenance service", 
  "LED lighting", "automation system", "waterfall feature", "deck resurfacing",
  "equipment upgrade", "saltwater conversion", "heater installation", "tanning ledge"
];

const firstNames = [
  "John", "Mary", "Robert", "Patricia", "Michael", "Jennifer", "William", "Linda",
  "David", "Barbara", "Richard", "Susan", "Joseph", "Jessica", "Thomas", "Sarah",
  "Charles", "Karen", "Christopher", "Nancy", "Daniel", "Lisa", "Matthew", "Betty",
  "Anthony", "Margaret", "Mark", "Sandra", "Donald", "Ashley", "Steven", "Kimberly",
  "Paul", "Emily", "Andrew", "Donna", "Joshua", "Michelle", "Kenneth", "Carol"
];

const lastNames = [
  "Smith", "Johnson", "Williams", "Brown", "Jones", "Garcia", "Miller", "Davis",
  "Rodriguez", "Martinez", "Hernandez", "Lopez", "Gonzalez", "Wilson", "Anderson",
  "Thomas", "Taylor", "Moore", "Jackson", "Martin", "Lee", "Thompson", "White",
  "Harris", "Sanchez", "Clark", "Ramirez", "Lewis", "Robinson", "Walker", "Young"
];

for (let i = 21; i <= 109; i++) {
  const firstName = firstNames[Math.floor(Math.random() * firstNames.length)];
  const lastName = lastNames[Math.floor(Math.random() * lastNames.length)];
  const city = texasCities[Math.floor(Math.random() * texasCities.length)];
  const service = serviceTypes[Math.floor(Math.random() * serviceTypes.length)];
  const rating = Math.random() > 0.1 ? 5 : 4; // 90% 5-star, 10% 4-star
  
  const reviews = [
    `Outstanding ${service} work! Professional team and excellent results. Highly recommend Waterlife!`,
    `Best decision we made! The ${service} exceeded all our expectations. Quality workmanship throughout.`,
    `Great experience with Waterlife. The ${service} was completed on time and looks amazing!`,
    `Couldn't be happier with our new ${service}. The team was professional and detail-oriented.`,
    `Excellent service from consultation to completion. Our ${service} is exactly what we wanted!`,
    `Top-notch ${service} installation. Fair pricing and exceptional quality. Will use them again!`,
    `Amazing job on our ${service}! The crew was respectful and cleaned up perfectly each day.`,
    `Very satisfied with the ${service} they provided. Professional, efficient, and high quality work.`,
    `The ${service} transformed our backyard! Waterlife delivered exactly what they promised.`,
    `Highly recommend for ${service}! Great communication and beautiful end result.`
  ];
  
  testimonials.push({
    id: i,
    name: `${firstName} ${lastName}`,
    location: `${city}, TX`,
    rating: rating,
    text: reviews[Math.floor(Math.random() * reviews.length)],
    image: `https://images.unsplash.com/photo-${1400000000000 + i * 100000000}?w=150&h=150&fit=crop`
  });
}


// Mock form submission handler
export const handleContactSubmit = (formData) => {
  console.log("Form submitted (mock):", formData);
  // Store in browser localStorage for demo purposes
  const submissions = JSON.parse(localStorage.getItem('contactSubmissions') || '[]');
  submissions.push({
    ...formData,
    timestamp: new Date().toISOString()
  });
  localStorage.setItem('contactSubmissions', JSON.stringify(submissions));
  return { success: true, message: "Thank you! We'll contact you soon." };
};
